import React from 'react';

import CounterpartiesPage from '@/features/counterparties/pages/counterparties.page';

const CounterpartiesRoute = () => {
  return <CounterpartiesPage />;
};

export default CounterpartiesRoute;
